import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button, Form, Input, Space } from 'tdesign-react';
import Tip from '@/components/Tip';
import Panel from '@/components/Panel';
import Variables from './Variables';

const { FormItem } = Form;

function ParamsStep({ preStep, cache, nextStep, type }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (cache) {
      form.setFieldsValue(cache);
    }
  }, [cache, form]);

  const handleSubmit = ({ validateResult, fields }) => {
    if (validateResult === true) {
      nextStep(fields);
    }
  };

  return (
    <Form form={form} labelWidth={150} onSubmit={handleSubmit}>
      <Root
        footer={
          <Space size='small'>
            <Button variant='outline' onClick={preStep}>
              上一步
            </Button>
            <Button theme='primary' onClick={() => form.submit()}>
              下一步
            </Button>
          </Space>
        }
      >
        <Title>填写说明</Title>
        <P>
          1）选填变量： 一般情况下不需要修改。选填变量具有默认值，
          如果需要修改，则需要再执行阶段进行选择并修改值。
        </P>
        <P>2）必填变量： 部署时，需要用户填写的变量。</P>
        <Divider />
        <FormItem
          label={
            <Tip content='需要替换的变量文件的目录（哪些目录下的j2文件需要执行替换）'>
              需要替换的目录
            </Tip>
          }
          name='variableSubstitutionPath'
          rules={[{ required: true }]}
        >
          <Input style={{ width: 340 }} placeholder='填写需要替换的目录, 默认conf,多个用逗号分割' />
        </FormItem>
        <FormItem name='packageVariables'>
          <Variables
            label='集群变量'
            variableLevel={0}
            type={type}
            tip='组件包级别变量，一个集群下该组件下所有机器的变量值相同，例如cluster_name'
          />
        </FormItem>
        {type === 0 && (
          <FormItem name='ipVariables'>
            <Variables
              label='IP变量'
              variableLevel={1}
              type={type}
              tip='IP级别变量，每个IP地址需要独立的变量值，例如本机IP'
            />
          </FormItem>
        )}
      </Root>
    </Form>
  );
}

export default connect((state) => ({
  type: state.template.cache[0].type,
}))(ParamsStep);

const Root = styled(Panel)`
  margin-top: 16px;
  display: flex;
  padding-top: 0;
  flex-direction: column;
  .shadow-card-footer {
    border-top: 1px solid #e7e7e7;
  }
`;

const Title = styled.h5`
  line-height: 2;
  margin-bottom: 4px;
`;

const P = styled.div`
  font-size: 14px;
  padding: 6px 0;
  font-style: normal;
  font-weight: 400;
  color: var(--td-font-gray-2);
`;

const Divider = styled.div`
  height: 2px;
  background: #edeff2;
  margin: 10px 0 18px;
  border-radius: 2px;
`;
